(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('changePhoneNumberRedesignCtrl', ['$scope', 'provinceMeta', '$sce', '$http', 'uteEndpoint', 'uteLocale', '$rootScope', '$stateParams', '$state', 'commonService', 'changePhoneNumberService', 'dataLayerService', 'dtmServiceConstants', '$translate', function ($scope, provinceMeta, $sce, $http, uteEndpoint, uteLocale, $rootScope, $stateParams, $state, commonService, changePhoneNumberService, dataLayerService, dtmServiceConstants, $translate) {

      $scope.provinces = _.keys(provinceMeta);
      $scope.showLoader = false;
      $scope.language=uteLocale.language;

      if (uteLocale.language == 'en') {
        var provinceMap = {};
        provinceMap['Alberta'] = 'ab';
        provinceMap['British Columbia'] = 'bc';
        provinceMap['Manitoba'] = 'mb';
        provinceMap['New Brunswick'] = 'nb';
        provinceMap['Newfoundland and Labrador'] = 'nl';
        provinceMap['Nova Scotia'] = 'ns';
        provinceMap['Ontario'] = 'on';
        provinceMap['Prince Edward Island'] = 'pe';
        provinceMap['Quebec'] = 'qc';
        provinceMap['Saskatchewan'] = 'sk';
        $scope.provinceList = provinceMap;
      } else {
        var provinceMap = {};
        provinceMap['Alberta'] = 'ab';
        provinceMap['Colombie-Britannique'] = 'bc';
        provinceMap['Manitoba'] = 'mb';
        provinceMap['Nouveau-Brunswick'] = 'nb';
        provinceMap['Terre-Neuve-et-Labrador'] = 'nl';
        provinceMap['Nouvelle-Écosse'] = 'ns';
        provinceMap['Ontario'] = 'on';
        provinceMap['Île-du-Prince-Édouard'] = 'pe';
        provinceMap['Québec'] = 'qc';
        provinceMap['Saskatchewan'] = 'sk';
        $scope.provinceList = provinceMap;
      }
      var selectedAccountDetail = '';
      $scope.errorPayload = {
        page: dtmServiceConstants.dataLayerTrack.page.changeCtn.error
      };

      $scope.errorFormPayload = {
        page: dtmServiceConstants.dataLayerTrack.page.changeCtn.start
      };

      //since ng-repeat creates some child scope, so wrap it around parent scope
      $scope.data = {
          provinceSelected:'',
          selectedCityDesktop:''
      };

      $scope.screenToShow = 'findAvailableNumbers';

      if ($stateParams.accountNumber) {
        selectedAccountDetail = _.find(commonService.accountDetails, function (accountDetail) {
          return accountDetail.accountNumber === $stateParams.accountNumber
        });
      }
      if (!$stateParams.accountNumber) {
        $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
      }
      if (!$stateParams.ctn) {
        $stateParams.ctn = $rootScope.userInfo.selectedSubscriberNo;
      }
      var accountNumber = $stateParams.accountNumber;
      $scope.accountNumber = $stateParams.accountNumber;
      $scope.ctn = $stateParams.ctn;

      if (selectedAccountDetail) {
        if (selectedAccountDetail.LOB === 'WL') {
          $scope.customerType = 'postpaid';
        }
        else {
          $scope.customerType = 'prepaid';
        }
      }

      $scope.getBaseLocation = function () {
        $scope.showLoader = true;
        $http({
          method: "POST",
          url: uteEndpoint('v1/wirelesss/changenumber/baselocation'),
          data: {
            accountNumber: $stateParams.accountNumber,
            ctn: $stateParams.ctn
          }
        }).success(function (response) {
          $scope.showLoader = false;
          if (_.isEmpty(response.error)) {
            $scope.cityCode = response.baseCity;
            var baseProvince = response.baseProvince.toUpperCase();
            $.each(provinceMap, function(key, value) {
              if (key.toUpperCase() === baseProvince) {
                $scope.data.provinceSelected = value;
              }
            });
            $scope.init();
          } else {
            $scope.errorMessage = 'errorOccurred';
            $scope.data.provinceSelected = uteLocale.province;
          }
        }).error(function (response) {
          $scope.showLoader = false;
          $scope.errorMessage = 'errorOccurred';
          $scope.data.provinceSelected = uteLocale.province;
        });
      };

      $scope.proceedToNumberSelection = function (form){
        if (form.$valid) {
          $state.go('myAccount.changePhoneNumberRedesignSelection', {
            'accountNumber': $scope.accountNumber,
            'ctn': $scope.ctn,
            'selectedCityCode': $scope.data.selectedCityDesktop,
            'selectedProvinceCode': $scope.data.provinceSelected
          });
        }
      };

      $scope.init = function () {
        $scope.cityList = '';
        $scope.errorMessage = '';
        $scope.data.selectedCityDesktop = '';
        $scope.showLoader = true;

        $http({
          method: "POST",
          url: uteEndpoint('v1/wirelesss/changenumber/citylist'),
          data: {
            accountNumber: $stateParams.accountNumber,
            ctn: $stateParams.ctn,
            provinceCode: $scope.data.provinceSelected,
          }
        }).success(function (response) {
          $scope.showLoader = false;
          if (_.isEmpty(response.error)) {
            $scope.cityList = response.cityList;
            _.each($scope.cityList,function (city){
              if(city.cityCode === $scope.cityCode){
                $scope.data.selectedCityDesktop = city.cityCode;
              }
            });
            changePhoneNumberService.setCityList($scope.cityList);
          } else {
            $scope.cityList = '';
            $scope.errorMessage = 'errorOccurred';
          }
        }).error(function (response) {
          $scope.showLoader = false;
          $scope.cityList = '';
          $scope.errorMessage = 'errorOccurred';
        });
      };

      $scope.checkCtnEligibleToChange = function(){
        $http({
           method: "POST",
           url: uteEndpoint('v1/wireless/changenumber/changectncount'),
          data: {
            accountNumber: $stateParams.accountNumber
          }
        }).success(function (response, status, headers, config) {
          $scope.showLoader = false;
          if (!(_.isEmpty(response))) {
            if (response.isExceeded || !_.isEmpty(response.error)) { // response.error returns 5000 or response.isExceeded return as true
              $scope.eligibleMessage = 'notEligibleToChange';
              if(response.isExceeded){
                $translate('global.error.label.ctnExceedMessage').then(function (translatedValues) {
                  var errorCode = angular.isString(response.error) ? response.error : '';
                  var apiUrl = (config && config.url)? config.url : dtmServiceConstants.dataLayerTrack.page.changeCtn.errorType.changeCtnCount;
                  dataLayerService.trackServerSideError($scope.errorPayload, translatedValues, errorCode, apiUrl);
                });
              }
            } else {
              $scope.eligibleMessage = 'eligibleToChange';
              $scope.getBaseLocation();
            }
          }
        }).error(function (response) {
          $scope.showLoader = false;
          $scope.eligibleMessage = 'notEligibleToChange';
        });
      };

      $scope.checkCtnEligibleToChange();

    }]);

})();
